var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var StatusRecord_1;
import '@symon-ai/wisepipe-common'; // force import for JsonSchema
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { Utils } from '@symon-ai/wisepipe-common';
export var StatusCheckingService;
(function (StatusCheckingService) {
    StatusCheckingService["Import"] = "import";
    StatusCheckingService["Calc"] = "calc";
    StatusCheckingService["Export"] = "export";
    StatusCheckingService["Pipe"] = "pipe";
    StatusCheckingService["Auth"] = "auth";
    StatusCheckingService["Run"] = "run";
})(StatusCheckingService || (StatusCheckingService = {}));
export var Status;
(function (Status) {
    Status["Completed"] = "completed";
    Status["Failed"] = "failed";
})(Status || (Status = {}));
export var StatusCheckConstants;
(function (StatusCheckConstants) {
    StatusCheckConstants["PipeStatusPipe"] = "Pipe Status Check Pipe";
    StatusCheckConstants["CalcStatusPipe"] = "Calc Status Check Pipe";
    StatusCheckConstants["RunStatusData"] = "Run Status Check Data";
    StatusCheckConstants["RunStatusPipe"] = "Run Status Check Pipe";
    StatusCheckConstants["RunStatusRun"] = "Run Status Check Run";
    StatusCheckConstants["ImportStatusData"] = "check_import_status.csv";
})(StatusCheckConstants || (StatusCheckConstants = {}));
const StatusRecordSchema = {
    $id: 'urn:wisepipe-common:StatusRecord',
    type: 'object',
    properties: {
        createdAt: { type: 'number' },
        expiredAt: { type: 'number' },
        processID: { type: 'string' },
        serviceType: {
            type: 'string',
            enum: Object.values(StatusCheckingService)
        },
        status: {
            type: 'string',
            enum: Object.values(Status)
        },
        durationInSeconds: { type: 'number' }
    },
    required: ['createdAt', 'expiredAt', 'serviceType', 'status']
};
let StatusRecord = StatusRecord_1 = class StatusRecord {
    constructor(serviceType, createdAt, status, expiredAt, processID, durationInSeconds) {
        this.serviceType = serviceType;
        this.createdAt = createdAt;
        this.status = status;
        this.expiredAt = expiredAt;
        if (processID)
            this.processID = processID;
        if (durationInSeconds)
            this.durationInSeconds = durationInSeconds;
        JSON.validate(this, StatusRecord_1);
    }
    static bufferID(base64ID) {
        return Utils.base64StringToBuffer(base64ID);
    }
};
StatusRecord = StatusRecord_1 = __decorate([
    JsonSchema(StatusRecordSchema)
], StatusRecord);
export { StatusRecord };
//# sourceMappingURL=statusRecord.js.map